export { default as Interpolation } from './src/interpolation';
export { default as useInterpolation } from './src/use-interpolation';
export { default as useInterpolationVars } from './src/use-interpolation-vars';
